module.exports = __webpack_public_path__ + "img/icon-display-grid.97527d02.svg";